import { Button, Form, Input, Table, Tooltip } from "antd";
import { useContext, useEffect, useState } from "react";
import { ExportToExcel } from "../../utils/exportExcel";

import { useQuery } from "@tanstack/react-query";
import { handleExportUsers, handleFetchUsers } from "../../api/users";
import Something from "../../components/shared/Something";
import UploadUsers from "./components/UploadUsers";
import { ColumnsType } from "antd/es/table";
import UpdateUser from "./components/UpdateUser";
import { AuthContext } from "../../contexts/AuthContext";
import {
  CheckCircleFilled,
  CloseCircleOutlined,
  CrownOutlined,
  DeleteOutlined,
  EditFilled,
  FileExcelOutlined,
  FilterOutlined,
  ReloadOutlined,
  SafetyCertificateOutlined,
  SwapOutlined,
  UploadOutlined,
  WarningOutlined,
} from "@ant-design/icons";
import UpdateUnit from "./components/UpdateUnit";
import DeleteUser from "./components/DeleteUser";
import { Plus } from "lucide-react";
import CreateUser from "./components/CreateUser";

const { Search } = Input;

export default function Users() {
  const { user } = useContext(AuthContext);
  const [selected, setSelected] = useState<any>({});
  const [createModal, setCreateModal] = useState<boolean>(false);
  const [uploadModal, setUploadModal] = useState<boolean>(false);
  const [levelModal, setLevelModal] = useState<boolean>(false);
  const [locateModal, setLocateModal] = useState<boolean>(false);
  const [deleteModal, setDeleteModal] = useState<boolean>(false);
  const [updateModal, setUpdateModal] = useState<boolean>(false);

  const [isExporting, setExporting] = useState<boolean>(false);
  const [form] = Form.useForm();
  const access = [9];

  const initials = {
    name: "",
  };

  const [filters, setFilters] = useState<any>({ ...initials });

  const params = `name=${filters?.name}`;

  const [pagination, setPagination] = useState<any>({
    page: 1,
    limit: 10,
    total: 0,
  });

  const {
    data: users,
    refetch,
    isLoading,
    isFetching,
    isError,
  } = useQuery({
    queryKey: ["users", pagination.page, pagination.limit, params],
    queryFn: () =>
      handleFetchUsers({
        page: pagination.page,
        limit: pagination.limit,
        params,
      }),
  });

  const handlePageChange = (e: any) => {
    setPagination((prev: any) => ({
      ...prev,
      page: e.current,
      limit: e.pageSize,
    }));
  };

  const clearAllFilters = async () => {
    form.resetFields();
    setFilters({ ...initials });
    handleRefetch();
  };
  const handleRefetch = () => {
    refetch();
  };

  interface DataType {
    key: React.Key;
    name: string;
    age: number;
    address: string;
  }
  const getColumns = (user: any, access: any) => {
    const columns: ColumnsType<DataType> = [
      {
        title: "S/N",
        width: 60,
        render: (record: any, text: any, index: any) => (
          <span className="text-gray-700 ml-2">
            {pagination?.page * pagination?.limit -
              pagination?.limit +
              index +
              1}
          </span>
        ),
      },
      {
        title: "EMP_ID",
        width: 80,
        render: (record: any) => {
          return <span className="text-gray-700">{record?.empId || "-"}</span>;
        },
      },
      {
        title: "FULLNAME",
        width: 160,
        render: (record: any) => {
          return (
            <div className="text-gray-700">
              <div className="">{record?.name || "-"}</div>
              {record?.isAdmin && (
                <div className="flex items-center">
                  <div className="">
                    <CrownOutlined color="#16a34a" />
                  </div>
                  <div className="mx-1 text-green-600">Admin</div>
                </div>
              )}
            </div>
          );
        },
      },
      {
        title: "EMAIL",
        width: 140,
        render: (record: any) => (
          <span className="text-gray-700">{record?.email || "-"}</span>
        ),
      },
      {
        title: "MOBILE",
        width: 80,
        render: (record: any) => (
          <span className="text-gray-700">{record?.mobile || "-"}</span>
        ),
      },
      {
        title: "CLUSTER",
        width: 110,
        render: (record: any) => (
          <span className="text-gray-700">{record?.cluster || "-"}</span>
        ),
      },
      {
        title: "LEGAL ENTITY",
        width: 140,
        render: (record: any) => (
          <span className="text-gray-700">{record?.legalEntity || "-"}</span>
        ),
      },
      {
        title: "CO. No.",
        width: 60,
        render: (record: any) => (
          <span className="text-gray-700">{record?.companyNo || "-"}</span>
        ),
      },
      {
        title: "BUSINESS SEGMENT",
        width: 140,
        render: (record: any) => (
          <span className="text-gray-700">
            {record?.businessSegment || "-"}
          </span>
        ),
      },
      {
        title: "BUSINESS DIVISION",
        width: 140,
        render: (record: any) => (
          <span className="text-gray-700">
            {record?.businessDivision || "-"}
          </span>
        ),
      },
      {
        title: "BUSINESS UNIT",
        width: 150,
        render: (record: any) => (
          <span className="text-gray-700">{record?.businessUnit || "-"}</span>
        ),
      },
      {
        title: "ASSIGNED B.U",
        width: 150,
        render: (record: any) => (
          <div className="flex items-center w-full">
            {record?.businessUnitRef ? (
              <div className="flex items-center justify-between">
                <div className="flex items-center">
                  <div className="mr-1">
                    {record?.isLocated ? (
                      <CheckCircleFilled color="#15803d" />
                    ) : (
                      <WarningOutlined color="#dc2626" />
                    )}
                  </div>
                  <div className="text-gray-700">
                    {record?.businessUnitRef?.name}
                  </div>
                </div>
                <div className="">
                  <button
                    onClick={() => {
                      setSelected(record);
                      setLocateModal(true);
                    }}
                  >
                    <SwapOutlined />
                  </button>
                </div>
              </div>
            ) : (
              <button
                onClick={() => {
                  setSelected(record);
                  setLocateModal(true);
                }}
                className="bg-blue-100 border shadow-sm px-4 py-1"
              >
                Assign
              </button>
            )}
          </div>
        ),
      },
      {
        title: "DEPARTMENT",
        width: 110,
        render: (record: any) => (
          <span className="text-gray-700">{record?.department || "-"}</span>
        ),
      },
      {
        title: "ACTIVE",
        width: 80,
        render: (record: any) => (
          <span className="text-gray-700">
            {record?.isActive ? (
              <div className="text-green-600 flex items-center">
                <div className="flex items-center">
                  <SafetyCertificateOutlined size={18} />{" "}
                  <span className="mx-1">YES</span>
                </div>
              </div>
            ) : (
              <div className="text-red-600 flex items-center">
                <CloseCircleOutlined size={18} />{" "}
                <span className="mx-1">NO</span>
              </div>
            )}
          </span>
        ),
      },

      {
        title: "IMPERSONATE",
        width: 120,
        render: (record: any) => (
          <span className="text-gray-700">
            {record?.canImpersonate ? (
              <div className="text-green-600 flex items-center">
                <div className="flex items-center">
                  <SafetyCertificateOutlined size={18} />{" "}
                  <span className="mx-1">YES</span>
                </div>
              </div>
            ) : (
              <div className="text-red-600 flex items-center">
                <CloseCircleOutlined size={18} />{" "}
                <span className="mx-1">NO</span>
              </div>
            )}
          </span>
        ),
      },
      {
        title: "ACCESS",
        width: 80,
        fixed: "right",
        render: (record: any) => (
          <div className="text-gray-700 flex items-center group">
            Level : {record?.accessLevel}
            {access?.includes(user?.accessLevel) && (
              <button
                onClick={() => {
                  setSelected(record);
                  setLevelModal(true);
                }}
                className="mx-1 opacity-0 group-hover:opacity-100 transition-opacity duration-200"
              >
                <EditFilled />
              </button>
            )}
          </div>
        ),
      },
      {
        title: "ACTION",
        width: 120,
        fixed: "right",
        render: (record: any) => (
          <div className="">
            {/* {access?.includes(user?.accessLevel) && ( */}
            <div className="flex items-center">
              <button
                onClick={() => {
                  setSelected(record);
                  setUpdateModal(true);
                }}
                className="border py-1 px-2 mx-1 flex items-center bg-yellow-50 text-yellow-800 shadow-sm hover:bg-yellow-100"
              >
                <EditFilled />
              </button>

              <button
                onClick={() => {
                  setSelected(record);
                  setDeleteModal(true);
                }}
                className="border py-1 px-2 mx-1 flex items-center bg-red-50 text-red-800 shadow-sm hover:bg-red-100"
              >
                <DeleteOutlined />
              </button>
            </div>
            {/* )} */}
          </div>
        ),
      },
    ];
    return columns.filter((column: any) => {
      if (column.title === "ACTION") {
        return access.includes(user?.accessLevel);
      }
      return true;
    });
  };

  const columns = getColumns(user, access);

  const exportUsers = async () => {
    setExporting(true);
    const users = await handleExportUsers();
    await ExportToExcel(
      users?.map((item: any) => {
        return {
          EMP_ID: item?.empId || "-",
          EMAIL: item?.email || "-",
          FULLNAME: item?.name || "-",
          BUSINESS_UNIT: item?.businessUnit || "-",
          LEGAL_ENTITY: item?.legalEntity || "-",
          MOBILE: item?.mobile || "-",
        };
      }),
      "Users.xlsx"
    );
    setExporting(false);
  };

  useEffect(() => {
    setPagination({ ...pagination, total: users?.total });
  }, [users]);

  return (
    <div className="bg-gray-100">
      <div className="bg-white m-1">
        <div className="flex flex-col sm:flex-row justify-between border-b p-2">
          <div className="">
            <div className="font-bold text-lg">System Users</div>
            <div className="text-gray-600">Manage User Details</div>
          </div>

          <div className="flex">
            <div className="flex">
              <Form layout="inline" form={form}>
                <Form.Item name="name">
                  <Search
                    placeholder="Search name"
                    className="rounded-none"
                    allowClear
                    onSearch={(e: any) => {
                      setFilters({ ...filters, name: e });
                    }}
                  />
                </Form.Item>
              </Form>
              <Button
                className="ml-2 focus:outline-none hover:bg-red-100 rounded-none shadow-sm"
                onClick={() => {
                  clearAllFilters();
                }}
              >
                <FilterOutlined color="gray" />
              </Button>
            </div>
            <Tooltip title="Export To Excel">
              <button
                className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100 shadow-sm"
                onClick={() => exportUsers()}
              >
                {isExporting ? (
                  <ReloadOutlined />
                ) : (
                  <FileExcelOutlined size={20} />
                )}
              </button>
            </Tooltip>
            {access.includes(user?.accessLevel) && (
              <div className="flex">
                <button
                  onClick={() => setUploadModal(true)}
                  className="flex mx-2 justify-center items-center border px-4 h-8 bg-karimjee hover:bg-karimjee-dark text-white shadow-sm"
                >
                  <UploadOutlined /> <span className="mx-2">Upload</span>
                </button>
                <button
                  onClick={() => setCreateModal(true)}
                  className="flex mx-2 justify-center items-center border px-4 h-8  hover:bg-gray-100"
                >
                  <Plus size={15} /> <span className="mx-2">New</span>
                </button>
              </div>
            )}
          </div>
        </div>
        {isError ? (
          <Something refetch={refetch} isFetching={isFetching} />
        ) : (
          <div className="border p-2">
            <Table
              size="small"
              dataSource={users?.records}
              columns={columns}
              scroll={{ y: 660, x: 0 }}
              rowKey="id"
              bordered
              pagination={{
                current: pagination?.page,
                pageSize: pagination?.limit,
                total: pagination?.total,
              }}
              onChange={(e: any) => handlePageChange(e)}
              loading={isLoading}
            />
          </div>
        )}
      </div>

      <UploadUsers
        isVisible={uploadModal}
        setVisible={setUploadModal}
        selected={selected}
        refetch={refetch}
      />

      <CreateUser
        isVisible={createModal}
        setVisible={setCreateModal}
        selected={selected}
      />

      <UpdateUser
        isVisible={updateModal}
        setVisible={setUpdateModal}
        selected={selected}
      />

      <UpdateUnit
        isVisible={locateModal}
        setVisible={setLocateModal}
        selected={selected}
      />

      <DeleteUser
        isVisible={deleteModal}
        setVisible={setDeleteModal}
        selected={selected}
      />
    </div>
  );
}
